import { InjectionToken } from '@angular/core';

export const PACKAGES_API_URL = new InjectionToken<string>('PACKAGES_API_URL');